module.exports = __webpack_public_path__ + "img/BWarChariot64_ua.6d6ebf19.webp";